var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Report Recipient - Invite"}},[_c('CopyToInviteForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }